import { callService, loadWebtexte } from "@phoenixreisen/gateway";
export const Model = {
    webtexte: null,
};
export function canSEPA(booking) {
    return booking?.["buchung/sepa-mandat-erfassung-moeglich?"] === true;
}
export function getSEPA(booking) {
    return booking?.["buchung/sepa-mandat"] ?? null;
}
export function hasSEPA(booking) {
    return getSEPA(booking) !== null;
}
export async function getWebtexte() {
    const categories = ["meine_bank__einleitung"];
    return loadWebtexte(categories, "webtexte.meine-bank");
}
export async function save(jwt, rechnr, owner, iban) {
    return callService("meinphoenixservices.sepa", {
        "remote-addr": "set by backend",
        type: "sepa-mandat-erfassen",
        "konto-inhaber": owner,
        "rech-nr": rechnr,
        iban: iban,
        jwt: jwt,
    });
}
export default Model;
